<script setup lang="ts">
import SourceInput from '@components/form/input-base-components/source-input.vue';
import { useAttrs } from 'vue';
import {
    ModelValueEmitsType,
    ModelValuePropsInterface,
    useModelValueComposable,
} from '@components/form/compsables/model-value-composable.js';
import { FocusProps, useFocusComposable } from '@components/form/compsables/focus-composable.js';
import { useSingleRefComposable } from '@src/application/composables/single-ref-composable.js';
import { MaxLengthProps, useMaxLengthComposable } from '@components/form/compsables/maxLengthComposable.js';
import {
    FormPartEmitsType,
    FormPartProps,
    useFormPartComposable,
} from '@src/form/composables/form-part-composable.js';

defineProps<FormPartProps & ModelValuePropsInterface<string|null> & FocusProps & MaxLengthProps>();

defineEmits<FormPartEmitsType & ModelValueEmitsType<string|null>>();

const { setSingleTemplateRef, singleRef } = useSingleRefComposable<InstanceType<typeof SourceInput>>();
const { modelValue, exposes: modelValueExposes } = useModelValueComposable<string|null>();
const { validateMaxLength } = useMaxLengthComposable();
const { submit, validationMessage, exposes: formPartExposes } = useFormPartComposable(modelValue, () => validateMaxLength(modelValue, validationMessage));
const { exposes: focusExposes } = useFocusComposable(singleRef);

defineExpose(
    {
        ...formPartExposes,
        ...focusExposes,
        ...modelValueExposes,
        selectText: () => singleRef.value?.selectText(),
    },
);

const attrs = useAttrs();
</script>

<template>
    <SourceInput
        :ref="setSingleTemplateRef"
        v-model="modelValue"
        :form="form"
        v-bind="attrs"
        :name="name"
        :validation-message="validationMessage"
        @submit="submit"
    />
</template>
